











































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import numeral from 'numeral';

@Component
export default class TaxFees extends Vue {
    @Prop({ required: true })
    private quotation!: any;

    private get q(): any {
        return this.quotation || {};
    }

    private get condition(): string {
        return String(this.q.declaration_condition || '').toUpperCase().trim();
    }

    private get isSeaCondition(): boolean {
        return ['EFC', 'FCL', 'LCL'].indexOf(this.condition) !== -1;
    }

    // Nhóm 1: Thuế & Ủy thác (ETL/EFT/ECL/EFC/LTL4/LTL5)
    private get showTaxGroup(): boolean {
        return ['ETL', 'EFT', 'ECL', 'EFC', 'LTL4', 'LTL5'].indexOf(this.condition) !== -1;
    }

    // Nhóm 2: Gia cố / Kiểm đếm / Cước (ETL/ECL/LTL1-5)
    private get showCargoGroup(): boolean {
        return ['ETL', 'ECL', 'LTL1', 'LTL2', 'LTL3', 'LTL4', 'LTL5'].indexOf(this.condition) !== -1;
    }

    // Nhóm 3: Bảo hiểm / Ship nội địa TQ (tất cả trừ thuần nội địa)
    private get showInsGroup(): boolean {
        return ['ETL', 'EFT', 'ECL', 'EFC', 'LTL1', 'LTL2', 'LTL3', 'LTL4', 'LTL5', 'FTL', 'LCL', 'FCL'].indexOf(this.condition) !== -1;
    }

    // Phụ phí tờ khai (11) (ETL/ECL/LTL1-5/LCL)
    private get showCustomsSurcharge(): boolean {
        return ['ETL', 'ECL', 'LTL1', 'LTL2', 'LTL3', 'LTL4', 'LTL5', 'LCL'].indexOf(this.condition) !== -1;
    }

    // C/O (12) & Tờ khai (14) (LTL1-5)
    private get showCOAndDeclaration(): boolean {
        return ['LTL1', 'LTL2', 'LTL3', 'LTL4', 'LTL5'].indexOf(this.condition) !== -1;
    }

    // DV Hải Quan (13) (LTL2-5)
    private get showDVHQ(): boolean {
        return ['LTL2', 'LTL3', 'LTL4', 'LTL5'].indexOf(this.condition) !== -1;
    }

    // Handling fee (15) (LTL1-3)
    private get showHandling(): boolean {
        return ['LTL1', 'LTL2', 'LTL3'].indexOf(this.condition) !== -1;
    }

    // Giấy phép XK (16) (LTL3/4)
    private get showExportLicense(): boolean {
        return ['LTL3', 'LTL4'].indexOf(this.condition) !== -1;
    }

    // Phí vận hành chung (17-20)
    private get showOpsFees(): boolean {
        return ['ETL', 'EFT', 'ECL', 'EFC', 'LTL1', 'LTL2', 'LTL3', 'LTL4', 'LTL5', 'FTL', 'LCL', 'FCL'].indexOf(this.condition) !== -1;
    }

    // Thuế VAT hóa đơn (21) (ETL/EFT/ECL/EFC/LTL4/LTL5)
    private get showVATBillFee(): boolean {
        return ['ETL', 'EFT', 'ECL', 'EFC', 'LTL4', 'LTL5'].indexOf(this.condition) !== -1;
    }

    // Tên hiển thị động cho (9) Cước
    private get freightLabel(): string {
        switch (this.condition) {
            case 'EFT':
            case 'FTL':
                return '(9) Cước nguyên xe (Không VAT)';
            case 'EFC':
                return '(9) Cước công biển (Không VAT)';
            case 'FCL':
                return '(9) Cước công biển (Gồm VAT)';
            case 'LCL':
                return '(9) Cước lẻ biển (Gồm VAT)';
            default:
                return '(9) Cước vận chuyển (Không VAT)';
        }
    }

    // --- Các khoản tài chính & thuế ---
    private get totalCifValue(): number {
        if (this.q.total_cif_value !== undefined && Number(this.q.total_cif_value) > 0) {
            return Number(this.q.total_cif_value);
        }
        const usdRate = Number(this.q.usd_rate) || 25400;
        const items = this.q.items || [];
        const calculated = items.reduce((sum: number, item: any) => {
            const qty = Number(item.so_luong) || 0;
            const cifUsd = Number(item.xnk_don_gia_cif) || Number(item.xnk_don_gia_to_khai) || Number(item.gia_khai_hq_mac_dinh) || 0;
            if (cifUsd > 0) {
                return sum + cifUsd * qty * usdRate;
            }
            const thueNk = Number(item.thue_nk_dong) || 0;
            const thueNkPct = Number(item.thue_nk_phan_tram) || 0;
            if (thueNk > 0 && thueNkPct > 0) {
                return sum + thueNk / (thueNkPct / 100);
            }
            return sum + (Number(item.thanh_tien) || (Number(item.don_gia_hoa_don_kh) || 0) * qty);
        }, 0);
        return calculated > 0 ? calculated : (Number(this.q.total_goods) || 0);
    }

    private get invoiceValueForVat(): number {
        return Number(this.q.invoice_value_for_vat) || Number(this.q.total_goods) || 0;
    }

    private get tienHangNCC(): number {
        return Number(this.q.linked_orders_total) || 0;
    }

    private get thueNhapKhau(): number {
        if (this.q.thue_nhap_khau !== undefined) return Number(this.q.thue_nhap_khau);
        const items = this.q.items || [];
        return items.reduce((sum: number, i: any) => sum + (Number(i.thue_nk_dong) || 0), 0);
    }

    private get thueTuVe(): number {
        if (this.q.thue_tu_ve !== undefined) return Number(this.q.thue_tu_ve);
        const items = this.q.items || [];
        return items.reduce((sum: number, i: any) => sum + (Number(i.thue_tu_ve_dong) || 0), 0);
    }

    private get thueMoiTruong(): number {
        if (this.q.thue_moi_truong !== undefined) return Number(this.q.thue_moi_truong);
        const items = this.q.items || [];
        return items.reduce((sum: number, i: any) => sum + (Number(i.thue_moi_truong_dong) || 0), 0);
    }

    private get thueTTDB(): number {
        if (this.q.thue_ttdb !== undefined) return Number(this.q.thue_ttdb);
        const items = this.q.items || [];
        return items.reduce((sum: number, i: any) => sum + (Number(i.thue_ttdb_dong) || 0), 0);
    }

    private get thueVAT(): number {
        if (this.q.thue_vat !== undefined) return Number(this.q.thue_vat);
        const items = this.q.items || [];
        return items.reduce((sum: number, i: any) => sum + (Number(i.thue_vat_dong) || 0), 0);
    }

    private get thueVatXuatHoaDon(): number {
        if (this.q.thue_vat_xuat_hoa_don !== undefined) return Number(this.q.thue_vat_xuat_hoa_don);
        const items = this.q.items || [];
        return items.reduce((sum: number, i: any) => sum + (Number(i.thue_vat_xuat_hoa_don) || 0), 0);
    }

    private get vatWarning(): boolean {
        return this.showVATBillFee && this.thueVatXuatHoaDon < this.thueVAT && this.thueVAT > 0;
    }

    private get reinforcementCost(): number {
        return Number(this.q.reinforcement_fee) || 0;
    }

    private get phiBaoHiem(): number {
        return Number(this.q.insurance_fee) || 0;
    }

    private get phiKiemDem(): number {
        return Number(this.q.inspection_fee) || 0;
    }

    private get shipNoiDiaTQ(): number {
        return Number(this.q.china_domestic_shipping_fee) || 0;
    }

    private get phiVanChuyen(): number {
        return Number(this.q.shipping_fee) || 0;
    }

    private get phiUyThac(): number {
        return Number(this.q.entrustment_fee) || 0;
    }

    private get customsSurcharge(): number {
        return Number(this.q.customs_surcharge) || 0;
    }

    private get coFeeAmount(): number {
        return Number(this.q.co_fee) || 0;
    }

    private get dvhqFeeAmount(): number {
        return Number(this.q.dvhq_fee) || 0;
    }

    private get declarationFeeAmount(): number {
        return Number(this.q.declaration_fee) || 0;
    }

    private get handlingFeeAmount(): number {
        return Number(this.q.handling_fee_ltl) || 0;
    }

    private get exportLicenseFeeAmount(): number {
        return Number(this.q.export_license_fee) || 0;
    }

    private get specializedInspectionFee(): number {
        return Number(this.q.specialized_inspection_fee) || 0;
    }

    private get shipNoiDiaVN(): number {
        return Number(this.q.vn_domestic_shipping_fee) || 0;
    }

    private get loadingUnloadingFee(): number {
        return Number(this.q.loading_unloading_fee) || 0;
    }

    private get phiKhac(): number {
        return Number(this.q.other_fee) || 0;
    }

    private get giamTruAmount(): number {
        return Number(this.q.giam_tru) || 0;
    }

    private get doanhThuThuan(): number {
        if (this.q.net_revenue !== undefined && Number(this.q.net_revenue) > 0) {
            return Number(this.q.net_revenue);
        }
        return (
            this.phiVanChuyen +
            (this.showTaxGroup ? this.phiUyThac : 0) +
            (this.showHandling ? this.handlingFeeAmount : 0) +
            (this.showCustomsSurcharge ? this.customsSurcharge : 0)
        );
    }

    private get totalTaxAndFeeCost(): number {
        if (this.q.total_tax_and_fee_cost !== undefined && Number(this.q.total_tax_and_fee_cost) > 0) {
            return Number(this.q.total_tax_and_fee_cost);
        }
        const sum =
            (this.showTaxGroup ? (this.tienHangNCC + this.thueNhapKhau + this.thueTuVe + this.thueMoiTruong + this.thueTTDB) : 0) +
            (this.showCargoGroup ? (this.reinforcementCost + this.phiKiemDem) : 0) +
            (this.showInsGroup ? (this.phiBaoHiem + this.shipNoiDiaTQ) : 0) +
            this.phiVanChuyen +
            (this.showTaxGroup ? this.phiUyThac : 0) +
            (this.showCustomsSurcharge ? this.customsSurcharge : 0) +
            (this.showCOAndDeclaration ? (this.coFeeAmount + this.declarationFeeAmount) : 0) +
            (this.showDVHQ ? this.dvhqFeeAmount : 0) +
            (this.showHandling ? this.handlingFeeAmount : 0) +
            (this.showExportLicense ? this.exportLicenseFeeAmount : 0) +
            (this.showOpsFees ? (this.specializedInspectionFee + this.shipNoiDiaVN + this.loadingUnloadingFee + this.phiKhac) : 0) +
            (this.showVATBillFee ? this.thueVatXuatHoaDon : 0);
        return Math.max(0, Math.round(sum - this.giamTruAmount));
    }

    private get daThanhToanAmount(): number {
        return Number(this.q.total_paid) || 0;
    }

    private get canThanhToanAmount(): number {
        if (this.q.can_thanh_toan !== undefined) return Number(this.q.can_thanh_toan);
        return Math.max(0, this.totalTaxAndFeeCost - this.daThanhToanAmount);
    }

    private formatCurrency(val: number): string {
        if (!val) return '0 đ';
        return numeral(val).format('0,0') + ' đ';
    }
}
